export default "__VITE_ASSET__DpUIe8wz__"